import { ColorEnum } from '@/constants/color'
import { changeSearchOpen } from '@/features/pos/components/ProductCatalog/utils/changeSearchOpen'
import { changeSearchProduct } from '@/features/pos/components/ProductCatalog/utils/changeSearchProduct'
import SearchProductField from '@/features/pos/components/SearchProductField'
import BackButton from '@/features/pos/components/Tabs/parts/SearchTabsBar/parts/BackButton'
import SearchButton from '@/features/pos/components/Tabs/parts/SearchTabsBar/parts/SearchButton'
import { useSearchProductOpened } from '@/features/pos/hooks/search-product/useSearchProductOpened'
import { MaterialTopTabBar, MaterialTopTabBarProps } from '@react-navigation/material-top-tabs'
import { FC } from 'react'
import { StyleSheet, View } from 'react-native'

interface SearchTabsBarProps {
    activeScreen?: 'product-catalog' | 'order-finalization'
    topTabBarProps: MaterialTopTabBarProps
}

const SearchTabsBar: FC<SearchTabsBarProps> = ({ activeScreen, topTabBarProps }) => {
    const searchOpened = useSearchProductOpened()

    const handleBackPress = () => {
        changeSearchOpen(false)
        changeSearchProduct('')
    }

    if (activeScreen === 'order-finalization') return null

    if (searchOpened) {
        return (
            <View style={styles.container}>
                <BackButton onPress={handleBackPress} />
                <SearchProductField autoFocus />
            </View>
        )
    }

    return (
        <View style={styles.container}>
            <View style={styles.tabWrapper}>
                <MaterialTopTabBar {...topTabBarProps} />
            </View>
            <SearchButton onPress={() => changeSearchOpen(true)} />
        </View>
    )
}

const styles = StyleSheet.create({
    container: {
        height: 60,
        backgroundColor: ColorEnum.WHITE,
        paddingHorizontal: 16,
        flexDirection: 'row',
        alignItems: 'center',
    },
    tabWrapper: {
        flex: 1,
    },
})

export default SearchTabsBar
